import { render, staticRenderFns } from "./LombaAI.vue?vue&type=template&id=60ecc3c4&scoped=true"
import script from "./LombaAI.vue?vue&type=script&setup=true&lang=js"
export * from "./LombaAI.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LombaAI.vue?vue&type=style&index=0&id=60ecc3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ecc3c4",
  null
  
)

export default component.exports